import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"h-px bg-gray-100 my-6 dark:bg-gray-900\"></div>",{ moduleName: "codecrafters-frontend/components/settings/form-divider.hbs" })